import { useEffect, useState } from 'react';
import liveChatApi, { centralChatTicketsEnabled } from '../services/liveChatApi';
import { getStoredSessionToken } from '../services/sessionTokens';

// Use the chat service's authenticated identity, not the source application's
// unqualified ID or an agent display name. The server remains the authority.
export default function useChatActor(user, localDemo = false, retryKey = '') {
  const session = getStoredSessionToken();
  const sourceId = user?.id || '';
  const central = centralChatTicketsEnabled && !localDemo;
  const [actor, setActor] = useState(null);

  useEffect(() => {
    if (!central || !sourceId || !session) return undefined;
    let cancelled = false;
    let loading = false;
    let resolved = false;
    const load = async () => {
      if (loading || resolved || document.visibilityState === 'hidden') return;
      loading = true;
      try {
        const response = await liveChatApi.get('/api/chat/me');
        const id = response.data?.user?.id;
        if (!cancelled && getStoredSessionToken() === session && typeof id === 'string' && id) {
          resolved = true;
          setActor({ id, sourceId, session });
        }
      } catch {
        // Fail closed; opening actions again or returning to the tab retries.
      } finally {
        loading = false;
      }
    };
    load();
    window.addEventListener('focus', load);
    document.addEventListener('visibilitychange', load);
    return () => {
      cancelled = true;
      window.removeEventListener('focus', load);
      document.removeEventListener('visibilitychange', load);
    };
  }, [central, sourceId, session, retryKey]);

  if (!central) return sourceId;
  return actor?.sourceId === sourceId && actor?.session === session ? actor.id : '';
}
